/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_ResponsibilitiesInputs */

const th_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีม กิจกรรม และคำเชิญของคุณ`)
};

const en_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your teams, events and invitations`)
};

const ja_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分のチーム・イベント・招待`)
};

const zh_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的球队、赛事与邀请`)
};

const es_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus equipos, eventos e invitaciones`)
};

const pt_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus times, eventos e convites`)
};

const id_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim, acara dan undangan Anda`)
};

const fr_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos équipes, événements et invitations`)
};

const tl_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang mga team, event at paanyaya mo`)
};

const vi_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội, sự kiện và lời mời của bạn`)
};

const ko_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 팀, 이벤트, 초대`)
};

const de_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Teams, Events und Einladungen`)
};

const ru_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши команды, события и приглашения`)
};

const tr_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takımlarınız, etkinlikleriniz ve davetleriniz`)
};

const it_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tue squadre, i tuoi eventi e i tuoi inviti`)
};

const pl_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje drużyny, wydarzenia i zaproszenia`)
};

const uk_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваші команди, події та запрошення`)
};

const hi_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी टीमें, आयोजन और निमंत्रण`)
};

const ar_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فرقك وفعالياتك ودعواتك`)
};

const ms_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan, acara dan jemputan anda`)
};

const bn_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার দল, আয়োজন ও আমন্ত্রণ`)
};

const zh_tw2_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的球隊、賽事與邀請`)
};

const zh_hk2_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的球隊、賽事與邀請`)
};

const ur_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کی ٹیمیں، ایونٹ اور دعوتیں`)
};

const fa_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیم‌ها، رویدادها و دعوت‌های شما`)
};

const sw_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu, matukio na mialiko yako`)
};

const nl_profile_responsibilities = /** @type {(inputs: Profile_ResponsibilitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw teams, evenementen en uitnodigingen`)
};

/**
* | output |
* | --- |
* | "Your teams, events and invitations" |
*
* @param {Profile_ResponsibilitiesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const profile_responsibilities = /** @type {((inputs?: Profile_ResponsibilitiesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_ResponsibilitiesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_profile_responsibilities(inputs)
	if (locale === "ja") return ja_profile_responsibilities(inputs)
	if (locale === "zh") return zh_profile_responsibilities(inputs)
	if (locale === "es") return es_profile_responsibilities(inputs)
	if (locale === "pt") return pt_profile_responsibilities(inputs)
	if (locale === "id") return id_profile_responsibilities(inputs)
	if (locale === "fr") return fr_profile_responsibilities(inputs)
	if (locale === "tl") return tl_profile_responsibilities(inputs)
	if (locale === "vi") return vi_profile_responsibilities(inputs)
	if (locale === "ko") return ko_profile_responsibilities(inputs)
	if (locale === "de") return de_profile_responsibilities(inputs)
	if (locale === "ru") return ru_profile_responsibilities(inputs)
	if (locale === "tr") return tr_profile_responsibilities(inputs)
	if (locale === "it") return it_profile_responsibilities(inputs)
	if (locale === "pl") return pl_profile_responsibilities(inputs)
	if (locale === "uk") return uk_profile_responsibilities(inputs)
	if (locale === "hi") return hi_profile_responsibilities(inputs)
	if (locale === "ar") return ar_profile_responsibilities(inputs)
	if (locale === "ms") return ms_profile_responsibilities(inputs)
	if (locale === "bn") return bn_profile_responsibilities(inputs)
	if (locale === "zh-TW") return zh_tw2_profile_responsibilities(inputs)
	if (locale === "zh-HK") return zh_hk2_profile_responsibilities(inputs)
	if (locale === "ur") return ur_profile_responsibilities(inputs)
	if (locale === "fa") return fa_profile_responsibilities(inputs)
	if (locale === "sw") return sw_profile_responsibilities(inputs)
	if (locale === "nl") return nl_profile_responsibilities(inputs)
	return en_profile_responsibilities(inputs)
});